import { DecimalPipe } from '@angular/common';
import { CurrencyService } from '../services/currency.service';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'currencySymbol'
})
export class CurrencySymbolPipe implements PipeTransform {

    constructor(private currencyService: CurrencyService, private decimalPipe: DecimalPipe) { }

    transform(amount: any, format?: string, currencySymbol?: string): any {

        if (amount === null || amount === undefined) {
            return amount;
        }

        const symbol = currencySymbol ?? this.currencyService.currencySymbolValue;

        if (format == 'number2dp' && amount) {
            amount = this.decimalPipe.transform(amount, '1.2-2');
        }

        let withSymbol = `${symbol}${amount}`;

        if (amount < 0) {
            withSymbol = `-${symbol}${Math.abs(amount)}`;
        }

        if ((typeof amount === 'string' || amount instanceof String) && amount?.includes('-')) {
            withSymbol = `-${symbol}${amount.replace("-", "")}`;
        }

        return withSymbol;
    }

}
